var Membership;
(function (Membership) {
    var Controller = (function () {
        function Controller() {
            this.errorValidation = new ErrrorValidation.Controller();
            this.FormViewArray = {};
            this.emailInputWrapper = $('.inputWrapper');
            this.emailLabelElement = $('.labelForInput');

            //EVERYTIME NEW LOGIN FORMS IS MADE -
            //ADD FORM-ID AND SUBMIT-ID TO THIS ARRAY.
            //ADD CLICK EVENT
            //ADD SWITCH CASE
            this.loginFormArray = [{
                content: $('#loginWithGolfBox'),
                submit: $('#loginWithGbForm')
            }, {
                content: $('#loginWithSweden'),
                submit: $('#loginWithSwedenForm')
            }, {
                content: $('#loginWithFiGolfPiste'),
                submit: $('#loginWithFiGolfPisteForm')
            }, {
                content: $('#loginWithEnglandGolf'),
                submit: $('#loginWithEnglandGolfForm')
            }, {
                content: $('#loginWithScotlandGolf'),
                submit: $('#loginWithScotlandGolfForm')
            }, {
                content: $('#loginWithWalesGolf'),
                submit: $('#loginWithWalesGolfForm')
            }, {
                content: $('#loginWithBelgiumGolf'),
                submit: $('#loginWithBelgiumGolfForm')
            }, {
                content: $('#loginWithAustriaGolf'),
                submit: $('#loginWithAustriaGolfForm')
            }, {
                content: $('#loginWithAustraliaGolf'),
                submit: $('#loginWithAustraliaGolfForm')
            }];

            var _this = this;
            _this.EnsureLoginClick();
            _this.EnsureSignupClick();

            var validateForm = function (id) {
                var valid = true;
                $('#' + id + ' input[required], #' + id + ' select[required]').each(function () {
                    if ((!this.value || this.value === 'none')) {
                        valid = false;
                        return;
                    }
                });

                if (valid && $('#' + id + ' input[name="email"]').hasClass('inputError')) {
                    valid = false;
                }

                if (valid && !$('#termsAccepted')[0].checked) {
                    valid = false;
                }

                _this.ToggleSignUpActiveInactive(valid);
            }

            $('#membershipOptions').on('change', function () {
                _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, false);
                _this.errorValidation.ResetErrorBox($('.loginError'));
                helperController.ResetDropdownToDefault('#countriesOptions');
                _this.errorValidation.SuccessShowHide('active', 'inactive');
                var item = $(this);
                if (item.val() === '1') {
                    $('#membershipSignupformNone').removeClass('active specialActive');
                    _this.ToggleSignUpActiveInactive(false);
                    _this.ToggleCountryListQuestion(true);
                    _this.DoFormOperation(_this.ToggleLoginForm);
                    $('#disclaimer').toggle(false);
                }
                if (item.val() === 'default') {
                    _this.ToggleCountryListQuestion(false);
                    _this.DoFormOperation(_this.ToggleLoginForm);
                }
                if (item.val() === '0') {
                    $('#membershipSignupformNone').find("[name='email']").each(function () { if (this.value) { $(this).blur(); } });
                    $('#membershipSignupform').removeClass('active specialActive');
                    $('#membershipSignupformNone').addClass('active');
                    _this.ToggleSignUpActiveInactive(true);
                    _this.ToggleCountryListQuestion(false);
                    _this.DoFormOperation(_this.ToggleLoginForm);
                    $('#disclaimer').toggle(true);
                }

                validateForm('membershipSignupformNone');
            });

            $('#countriesOptions').on('change', function () {
                _this.errorValidation.ResetAll(_this.emailInputWrapper, _this.emailLabelElement, false);
                var item = $(this);
                _this.DoFormOperation(_this.ToggleLoginForm);
                _this.errorValidation.ResetErrorBox($('.loginError'));
                switch (item.val().toLowerCase()) {
                    case 'dk':
                    case 'no':
                    case 'ee':
                    case 'lt':
                    case 'lv':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithGbForm'), $('#loginWithGolfBox'));
                        }, 0);
                        break;
                    case 'se':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithSwedenForm'), $('#loginWithSweden'));
                        }, 0);
                        break;
                    case 'fi':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithFiGolfPisteForm'), $('#loginWithFiGolfPiste'));
                        }, 0);
                        break;
                    case 'en':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithEnglandGolfForm'), $('#loginWithEnglandGolf'));
                        }, 0);
                        break;
                    case 'sq':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithScotlandGolfForm'), $('#loginWithScotlandGolf'));
                        }, 0);
                        break;
                    case 'wl':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithWalesGolfForm'), $('#loginWithWalesGolf'));
                        }, 0);
                        break;
                    case 'be':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithBelgiumGolfForm'), $('#loginWithBelgiumGolf'));
                        }, 0);
                        break;
                    case 'at':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithAustriaGolfForm'), $('#loginWithAustriaGolf'));
                        }, 0);
                        break;
                    case 'au':
                        setTimeout(function () {
                            _this.ToggleLoginForm(true, $('#loginWithAustraliaGolfForm'), $('#loginWithAustraliaGolf'));
                        }, 0);
                        break;
                    default:
                        $('#membershipSignupform').addClass('active');
                        $('#disclaimer').toggle(true);
                        validateForm('membershipSignupform');
                }

                $('#membershipSignupform').find("[name='email']").each(function () { if (this.value) { $(this).blur(); } });
            });

            $('#membershipSignupform input, #membershipSignupform select, #termsAccepted').on('input change', function () {
                validateForm('membershipSignupform');
            });

            $('#membershipSignupformNone input, #membershipSignupformNone select, #termsAccepted').on('input change', function () {
                validateForm('membershipSignupformNone');
            });
        }

        Controller.prototype.EnsureLoginClick = function () {
            var _this = this;
            $('#loginWithGbForm').on('click', function () {
                _this.LoginHandler($('#gbLoginForm'), $('#loginWithGolfBox'), $('#countriesOptions').val());
            });
            $('#loginWithSwedenForm').on('click', function () {
                _this.LoginHandler($('#swedishFederationForm'), $('#loginWithSweden'), $('#countriesOptions').val());
            });
            $('#loginWithFiGolfPisteForm').on('click', function () {
                _this.LoginHandler($('#fiGolfPisteForm'), $('#loginWithFiGolfPiste'), $('#countriesOptions').val());
            });
            $('#loginWithEnglandGolfForm').on('click', function () {
                _this.LoginHandler($('#englandGolfForm'), $('#loginWithEnglandGolf'), $('#countriesOptions').val());
            });
            $('#loginWithScotlandGolfForm').on('click', function () {
                _this.LoginHandler($('#scotlandGolfForm'), $('#loginWithScotlandGolf'), $('#countriesOptions').val());
            });
            $('#loginWithWalesGolfForm').on('click', function () {
                _this.LoginHandler($('#walesGolfForm'), $('#loginWithWalesGolf'), $('#countriesOptions').val());
            });
            $('#loginWithBelgiumGolfForm').on('click', function () {
                _this.LoginHandler($('#belgiumGolfForm'), $('#loginWithBelgiumGolf'), $('#countriesOptions').val());
            });
            $('#loginWithAustriaGolfForm').on('click', function () {
                _this.LoginHandler($('#austriaGolfForm'), $('#loginWithAustriaGolf'), $('#countriesOptions').val());
            });
            $('#loginWithAustraliaGolfForm').on('click', function () {
                _this.LoginHandler($('#australiaGolfForm'), $('#loginWithAustraliaGolf'), $('#countriesOptions').val());
            });
        }

        Controller.prototype.LoginHandler = function (formElement, submitElement, country) {
            var _this = this;
            helperController.AjaxHelper('LogIn', 'json', formElement.serialize() + "&IsExternal=true&countryIsoCode=" + country, 'POST',
                function success(data) {
                    if (data.isValid && data.isDone) {
                        if ($('input[name="successUrl"]').length) {
                            window.location.href = $('input[name="successUrl"]').val();
                        } else {
                            window.location.href = "/";
                        }
                    } else {
                        _this.errorValidation.AddError(formElement.find('.inputWrapper'), formElement.find('.labelForInput'), data.message);
                        _this.ShowLoginError();
                        var id = submitElement.attr('id');
                        if (id === "loginWithAustriaGolf" || id === "loginWithEnglandGolf" || id === "loginWithBelgiumGolf") {
                            submitElement.addClass('specialActiveSpecialHeight');
                        } else {
                            submitElement.addClass('specialActive');
                        }
                    }
                },
                function failed(data) {
                    _this.errorValidation.AddError(formElement.find('.inputWrapper'), formElement.find('.labelForInput'), data.message);
                    _this.ShowLoginError();
                });
        }

        Controller.prototype.EnsureSignupClick = function () {
            var _this = this;
            $('#signupSubmitPlayerFormActive').on('click', function () {
                var data = "";
                var parent = null;
                var isValid = true;
                if ((parent = $('#membershipSignupform.active, #membershipSignupform.specialActive')).length) {
                    data = parent.serialize() + "&countryIsoCode=" + $('#countriesOptions').val();
                    _this.errorValidation.ResetAll(parent.find('.inputWrapper'), parent.find('.labelForInput'), false);
                    var membershipSignupInput = parent.find('.inputBox[required]');
                    membershipSignupInput.each(function (index, value) {
                        if (!inputValidator.IsValid($(value).val(), 100)) {
                            _this.errorValidation.AddError($(value).parent(), $(value).parent().prev(), "");
                            isValid = false;
                        }
                        return true;
                    });
                }
                if ((parent = $('#membershipSignupformNone.active, #membershipSignupformNone.specialActive')).length) {
                    data = parent.serialize();
                    _this.errorValidation.ResetAll(parent.find('.inputWrapper'), parent.find('.labelForInput'), false);
                    var membershipSignupNoneInput = parent.find('.inputBox[required]');
                    membershipSignupNoneInput.each(function (index, value) {
                        if (!inputValidator.IsValid($(value).val(), 100)) {
                            _this.errorValidation.AddError($(value).parent(), $(value).parent().prev(), "");
                            isValid = false;
                        }
                        return true;
                    });
                }

                if (data === "" || !isValid) return false;
                console.log('valid');
                helperController.AjaxHelper('MembershipRegister', 'json', data, 'POST',
                    function success(data) {
                        _this.errorValidation.ResetAll(parent.find('.inputWrapper'), parent.find('.labelForInput'), false);
                        _this.errorValidation.SuccessShowHide('inactive', 'active');
                        parent.removeClass('specialActive').addClass('active');
                    },
                    function failed(data) {
                        _this.errorValidation.AddError(parent.find('.inputWrapper'), parent.find('.labelForInput'), data.message);
                        _this.ShowLoginError();
                        parent.addClass('specialActive').removeClass('active');
                    });
            });
        };

        Controller.prototype.DoFormOperation = function (theFunctionToBeCalled) {
            var _this = this;
            $.each(_this.loginFormArray, function (index, value) {
                theFunctionToBeCalled(false, value.submit, value.content);
            });
        }

        Controller.prototype.ShowLoginError = function () {
            $('.loginError').removeClass('inactive').addClass('active');
        }

        Controller.prototype.ToggleLoginForm = function (doActive, submitElement, contentElement) {
            if (doActive) {
                $('#membershipSignupformNone').removeClass('active specialActive');
                $('#membershipSignupform').removeClass('active specialActive');
                $('#signupSubmitPlayerFormActive, #signupSubmitPlayerFormInactive').hide();
                submitElement.show();

                var id = contentElement.removeClass('inactive').attr('id');
                if (id === "loginWithAustriaGolf" || id === "loginWithEnglandGolf" || id === "loginWithBelgiumGolf") {
                    contentElement.addClass('loginActiveSpecialHeight');
                } else {
                    contentElement.addClass('loginActive');
                }
            } else {
                submitElement.hide();
                contentElement.removeClass('loginActive specialActiveSpecialHeight loginActiveSpecialHeight specialActive').addClass('inactive');
            }
            $('#disclaimer').toggle(false);
        }

        Controller.prototype.ToggleCountryListQuestion = function (doActive) {
            if (doActive) {
                $('#questionCountry').addClass('active').removeClass('inactive');
            } else {
                $('#questionCountry').addClass('inactive').removeClass('active');
            }
        }

        Controller.prototype.ToggleSignUpActiveInactive = function (doActive) {
            if (doActive) {
                $('#signupSubmitPlayerFormInactive').hide();
                $('#signupSubmitPlayerFormActive').show();
            } else {
                $('#signupSubmitPlayerFormInactive').show();
                $('#signupSubmitPlayerFormActive').hide();
            }
        }

        return Controller;
    })();
    Membership.Controller = Controller;
})(Membership || (Membership = {}));
$(function () {
    var controller = new Membership.Controller();
})